import React, { Component } from 'react'
import { Col, Row } from 'reactstrap'
import DadosGeraisAcomp from './DadosGeraisAcomp';
import MercadoriaAcomp from './MercadoriaAcomp';
import DetalhesAcomp from './DetalhesAcomp';
import DetalhesAcompMobile from './DetalhesAcompMobile';
import TimelineAcomp from './TimelineAcomp';
import ConsultaSituacaoAcomp from './ConsultaSituacaoAcomp';
import ConsultaArquivosProcessos  from './ConsultaArquivosProcesso';

export default class InfoAcomp extends Component {

    constructor(props){
        super(props)
    }

    render() {
        return (
            <div className="containers--lista">
                <Row className="mb-5">
                    <Col>
                        <DadosGeraisAcomp controller={this.props.controller} />
                    </Col>
                </Row>
                <Row className="mb-5">
                    <Col>
                        <TimelineAcomp controller={this.props.controller} />
                    </Col>
                </Row>
                <Row className={this.props.controller.tipoAcompanhamento !== 'E' ? 
                                (process.env.rig && ["E", "C"].includes(this.props.controller.tipoAcompanhamento)) ? "" : "mb-5" : ""} 
                >
                    <Col>
                        {!process.env.rig
                        ?<MercadoriaAcomp controller={this.props.controller} />
                        :["E", "C"].includes(this.props.controller.tipoAcompanhamento) ?  <div /> : <ConsultaSituacaoAcomp controller={this.props.controller} />}
                    </Col>
                </Row>
                
                <Row>
                    <Col>
                        {window.innerWidth > 991
                        ?
                        <DetalhesAcomp controller={this.props.controller} />
                        :
                        <DetalhesAcompMobile controller={this.props.controller} />
                        }
                    </Col>
                </Row>
                {/* <Row className="mb-5">
                    <Col>
                        <ConsultaArquivosProcessos controller={this.props.controller}/>
                    </Col>
                </Row> */}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/acompanhamento/components/InfoAcomp.js